import React from 'react';
import { CardComponent } from '../../../util/CardComponent';
import { userData } from '../../../util/userData';
import { redirectToUrl } from '../../UserAdministrationContainer/lib/utils';
import { useAppSelector } from '../hooks';
import { selectAllCommentsState } from './allCommentsSlice'

export function AllCommentComponent() {
  const allCommentState = useAppSelector(selectAllCommentsState);
  const { subtitle, isLoading, commentCount, comments } = allCommentState;

  function getCoachingForm(id, s) {
    if (id === null) {
      alert('Unable to loacte coaching form.');
      return;
    }
    const page = 'coaching_form?back=c&id=' + id + '&survey=' + s;
    window.open(page, '', 'width=800,height=800,scrollbars=1,resizable=1');
  }

  function redirectToCommentDetails() {
    const filters = userData.getFilters();
    const commentType = filters.commentType;
    if (!commentType) {
      filters.comment = 'allCodedComments';
      filters.commentType = 'allCodedComments';
    }
    userData.updateFilters(filters);
    redirectToUrl('commentdetails');
  }

  return (
    <div>
      <CardComponent
        title={''}
        isLoading={isLoading}
        disableCardBackgroundColor
      >
        <header>
          <h4>
            Comments&nbsp;&nbsp;
            {isLoading &&
              <i className="fa fa-cog fa-spin" />
            }
            <span className="badge right" style={{ verticalAlign: 'text-top' }}>
              <span className="link" onClick={() => {
                redirectToCommentDetails();
              }}>
                {commentCount}
              </span>
            </span>
          </h4>
        </header>
        <div>
          <div>{subtitle}</div>
          <div>
            {!isLoading &&
              <table style={{ height: '350px' }} id="allCommentsTable">
                <thead>
                  <tr>
                    <td>Sentiment</td>
                    <td>Category</td>
                    <td>Date</td>
                  </tr>
                </thead>
                <tbody style={{ overflowY: 'scroll', height: '900px' }}>
                  {comments.map(({ id, mood, comment, period, survey }) => {
                    const color =
                      id !== 'boo' ? 'var(--brand-blue) + !important' : '#1B3767 + !important';
                    const cursor = id !== 'boo' ? 'pointer' : 'default';

                    return (
                      <tr
                        key={id}
                        className="link"
                        onClick={() => {
                          getCoachingForm(id, survey);
                        }}
                      >
                        {mood === 'Both' ? (
                          <td className="text-center">
                            <img src="images/both_circle_24.png?v=3.1" alt="mood color indicator" />
                          </td>
                        ) : mood === 'Suggestion' ? (
                          <td className="text-center">
                            <img src="images/suggestion_circle_24.png?v=3.1" alt="mood color indicator" />
                          </td>
                        ) : mood === 'Compliment' ? (
                          <td className="text-center">
                            <img src="images/compliment_circle_24.png?v=3.1" alt="mood color indicator" />
                          </td>
                        ) : (
                          <td className="text-center" key={id}>
                            <img src="images/neutral_circle_24.png?v=3.1" alt="mood color indicator" />
                          </td>
                        )}
                        {comment.length > 100 ? (
                          <td>
                            <span
                              className="comments-tooltip"
                              style={{ color, cursor, }}
                              data-position="top"
                              data-tooltip={comment}
                              data-delay="50"
                            >
                              {comment.substring(0, 100) + '...'}
                            </span>
                          </td>
                        ) : (
                          <td>
                            <span
                              className="comments-tooltip"
                              style={{ color, cursor }}
                              data-position="top"
                              data-tooltip={comment}
                              data-delay="50"
                            >
                              {comment}
                            </span>
                          </td>
                        )}
                        <td>{period}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            }
          </div>
        </div>
      </CardComponent>
    </div>
  );
}
